import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  HostListener,
} from "@angular/core";

import { FilteringGuide } from "../models/filteringGuide";

import { StandardService } from "../services/standard.service";

import {
  FilteringEnum,
  CategoryEnum,
  StandardListType,
  UserRoleUserOperation,
  StandardTypeEnum,
  AddendumStatusEnum,
  UserRoleEnum,
  Constant,
} from "../core/constant";

import { Standard } from "../models/standard";

import { StandardList } from "../models/standard-list";

import { MatMenuTrigger } from "@angular/material/menu";

import { Router, ActivatedRoute } from "@angular/router";

import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";

import { CryptographyService } from "../services/cryptography.service";

import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { EquipmentStandard } from "../models/equipment-standard";

import { EquipmentStandardService } from "../services/equipment -standard.service";

import { Observable } from "rxjs";

import { environment } from "../../environments/environment";

import { NrbesSet } from "../models/nrbesSet";

import { Country } from "../models/country";

import { NrbesItem } from "../models/nrbesItem";

import { Category } from "../models/category";

import { LocationType } from "../models/location-type";

import { AddendumService } from "../services/addendum.service";

import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";

import { FailModuleComponent } from "../fail-module/fail-module.component";

import { FilterList } from "../models/filterList";

import { Sort } from "@angular/material/sort";

import { CustomEventNRService } from "../services/custom-event-nr.service";
import { SelectedStandard } from "../models/selected-standard";
import {
 
  AllStandardsTabs,
} from "../core/constant";
@Component({
  selector: "app-view-all-national-equipment-standard-list",

  templateUrl: "./view-all-national-equipment-standard-list.component.html",

  styleUrls: ["./view-all-national-equipment-standard-list.component.scss"],
})
export class ViewAllNationalEquipmentStandardListComponent implements OnInit {
  // Single variable to hold all items (both standards and nrbes)
exportSelectedIds :any[] = [];
  equipmentItems: any[] = [];

  selectedRowsForExport: any[] = [];

  activePopupId: any;

  totalPages: any;

  selectedCountryId: number = 0;

  userRole: number;

  userId: number;

  page: number = 1;

  nrbesSet: NrbesSet;

  countries: Country[] = [];

  pageSize: number = 10;

  collectionSize: number = 0;

  isDeleted: boolean = false;

  loading: boolean = false;

  searchKey: string = "";

  standards: Standard[] = [];

  categoryList: Category[] = [];

  locationTypeList: LocationType[] = [];

  filterList: FilteringGuide[] = [];

  pageSizes: any[] = Constant.PageSizes;

  // Flag to track which API to use

  isCountrySelected: boolean = false;

  // Flag to identify item type

  isNrbesData: boolean = false;

  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;

  equipmentStandard: EquipmentStandard = new EquipmentStandard();

  modalOption: NgbModalOptions = {};

  canEditNationalEquipmentStandard: boolean;

  canDeleteNationalEquipmentStandard: boolean;

  canRemoveEquipmentStandard: boolean;

  isDownloading: any = false;

  get standardListType() {
    return StandardListType;
  }

  get standardTypeEnum() {
    return StandardTypeEnum;
  }

  get addendumStatusEnum() {
    return AddendumStatusEnum;
  }

  get userRoleEnum() {
    return UserRoleEnum;
  }

  standardFiltrationForChipSet: FilterList = new FilterList();

  constructor(
    private standardService: StandardService,

    private equipmentStandardService: EquipmentStandardService,

    private addendumService: AddendumService,

    private router: Router,

    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,

    private cryptographyService: CryptographyService,

    private activatedRoute: ActivatedRoute,

    private ngbModal: NgbModal,

    private customEventNRService: CustomEventNRService,
  ) {}

  ngOnInit() {
    this.standardFiltrationForChipSet.standardListType =
      StandardListType.NationalEquipment;

    this.filterList =
      this.standardService.nationalEquipmentStandardFiltration.filterSet;

    this.pageSize =
      this.standardService.nationalEquipmentStandardFiltration.pageSize;

    this.searchKey =
      this.standardService.nationalEquipmentStandardFiltration.searchKey;

    this.page =
      this.standardService.nationalEquipmentStandardFiltration.startingIndex ||
      1;

    this.storage.set("equipmentfilterSet", JSON.stringify(this.filterList));

    this.userId = this.cryptographyService.decryptData(
      this.storage.get("userId"),
    );

    this.setUserPrivilages();

    this.userRole = this.getEffectiveUserRole();

    this.getMasterDataForNrbes().subscribe(() => {
      const sessionCountryId = parseInt(sessionStorage.getItem("selectedCountryID"));
      if(sessionCountryId){
         this.selectedCountryId = sessionCountryId
      }else{
              let selectedCountries =
        this.userRole == this.userRoleEnum.MarketAdmin ||
        this.userRole == this.userRoleEnum.BasicUser
          ? this.cryptographyService.decryptData(this.storage.get("countryId"))
          : this.standardService.nationalEquipmentStandardFiltration.countryId
            ? this.standardService.nationalEquipmentStandardFiltration.countryId
            : this.countries != null
              ? this.countries[0].id
              : this.cryptographyService.decryptData(
                  this.storage.get("countryId"),
                );

      if (typeof selectedCountries == "object") {
        this.selectedCountryId = selectedCountries[0];
      } else if (
        typeof selectedCountries == "string" ||
        typeof this.selectedCountryId == "number"
      ) {
        this.selectedCountryId = selectedCountries;
      }

      this.storage.set(
        "selectedCountryId",

        this.cryptographyService.encryptData(this.selectedCountryId),
      );
        
      }


      // Check if country is selected (not 0 or null or undefined)

      this.isCountrySelected =
        this.selectedCountryId && this.selectedCountryId !== 0;

      // Call appropriate API based on country selection

      if (this.isCountrySelected) {
        this.getAllNrbesBySelectedCountryId();
      } else {
        this.getStandards();
      }
    });
  }

  // ============ GET STANDARDS (When NO Country is Selected) ============

  getStandards(): void {
    this.loading = true;
    this.isNrbesData = false;
    this.standardService.nationalEquipmentStandardFiltration.startingIndex =
      this.page;
    this.standardService
      .getAllStandards(
        (this.page - 1) * this.pageSize,
        this.pageSize,
        StandardListType.GlobalEquipment,
        this.filterList,
        null,
        this.searchKey,
        this.getAppliedFilters(),
      )
      .subscribe(
        (data: StandardList) => {
          if (data && data.standardDetailList != null) {
            this.standards = data.standardDetailList.map(
              (o) => new Standard(o),
            );
            this.equipmentItems = this.standards;
          } else {
            this.standards = [];
            this.equipmentItems = [];
          }

          this.collectionSize = data?.count || 0;
          this.totalPages = Math.ceil(this.collectionSize / this.pageSize);
          this.loading = false;
        },
        (error: string) => {
          console.error(error);
          this.loading = false;
        },
      );
  }

  // ============ GET NRBES BY COUNTRY (When Country IS Selected) ============

  getAllNrbesBySelectedCountryId() {
    this.loading = true;

    this.isNrbesData = true;

    this.standardService.nationalEquipmentStandardFiltration.startingIndex =
      this.page;

    this.standardService

      .getNrbesByCountryId(
        this.userId,

        [this.selectedCountryId],

        (this.page - 1) * this.pageSize,

        this.pageSize,

        this.filterList,

        this.standardService.nationalEquipmentStandardFiltration.searchKey,

        true,
      )

      .subscribe(
        (data: NrbesSet) => {
          this.nrbesSet = data;

          // Map nrbes items to equipmentItems format

          this.equipmentItems =this.nrbesSet.nrbes

          this.collectionSize = data.count;

          this.totalPages = Math.ceil(this.collectionSize / this.pageSize);

          if (
            this.standardService.nationalEquipmentStandardFiltration.searchKey
          ) {
            this.customEventNRService.sendSearchEvent(
              "GrsSearchEvents",

              this.standardService.nationalEquipmentStandardFiltration
                .searchKey,

              this.collectionSize,

              window.location.href,
            );
          }

          this.loading = false;
        },

        (error) => {
          console.error(error);

          this.loading = false;
        },
      );
  }

  // ============ GET APPLIED FILTERS ============

  getAppliedFilters() {
    return [AllStandardsTabs.OperationsStandard];
  }

  // ============ RECEIVE FILTERATION FROM CHILD ============

  receivedFilteration($event) {
    console.log("Events ", $event)
    this.page = 1;

    this.filterList = $event;

    // this.standardService.nationalEquipmentStandardFiltration.filterSet =
    //   this.filterList;

    if (
      this.isCountrySelected &&
      this.selectedCountryId &&
      this.selectedCountryId !== 0
    ) {
       this.standardService.nationalEquipmentStandardFiltration.filterSet =
      this.filterList;
      this.getAllNrbesBySelectedCountryId();
    } else {
       this.standardService.equipmentStandardFiltration.filterSet =
      this.filterList;
      this.getStandards();
    }
  }

  // ============ SELECT COUNTRY ============

  selectCountry(event) {
    this.page = 1;

    this.selectedCountryId = event.id;

    this.standardService.nationalEquipmentStandardFiltration.countryId =
      event.value;

    this.storage.set(
      "selectedCountryId",

      this.cryptographyService.encryptData(this.selectedCountryId),
    );

    this.isCountrySelected =
      this.selectedCountryId && this.selectedCountryId !== 0;

    if (this.isCountrySelected) {
      this.getAllNrbesBySelectedCountryId();
    } else {
      this.getStandards();
    }
  }

  // ============ SELECT ITEMS PER PAGE ============

  selectedItemsPerPageChange(event) {
    this.page = 1;

    this.pageSize = event.value;

    this.standardService.nationalEquipmentStandardFiltration.pageSize =
      event.value;

    if (
      this.isCountrySelected &&
      this.selectedCountryId &&
      this.selectedCountryId !== 0
    ) {
      this.getAllNrbesBySelectedCountryId();
    } else {
      this.getStandards();
    }
  }

  // ============ ADD SEARCH KEY ============

  addSearchKey(searchKey) {
    this.searchKey = searchKey;

    this.page = 1;

  
   

    if (
      this.isCountrySelected &&
      this.selectedCountryId &&
      this.selectedCountryId !== 0
    ) {
       this.standardService.nationalEquipmentStandardFiltration.searchKey =
      this.searchKey;
      this.getAllNrbesBySelectedCountryId();
    } else {
      this.getStandards();
    }
  }

  // ============ ON SEARCH FROM CHILD ============

  onSearchFromChild(searchValue: string) {
    this.addSearchKey(searchValue);
  }

  // ============ ON COUNTRY FROM CHILD ============

  onCountryfromChild(event: any) {
    console.log("event child", event);

    this.selectCountry(event);
  }

  // ============ GET MASTER DATA FOR NRBES ============

  getMasterDataForNrbes(): Observable<any> {
    this.loading = true;

    return new Observable<any>((observer) => {
      this.standardService

        .GetMasterDataForAddNrbes(
          this.cryptographyService.decryptData(this.storage.get("userRole")),

          this.cryptographyService.decryptData(this.storage.get("userId")),
        )

        .subscribe((data: any) => {
          this.countries = data.countries;

          if (
            this.cryptographyService.decryptData(
              this.storage.get("userRole"),
            ) == this.userRoleEnum.MarketAdmin ||
            this.cryptographyService.decryptData(
              this.storage.get("userRole"),
            ) == this.userRoleEnum.BasicUser
          ) {
            this.countries = this.countries.filter((x) =>
              this.cryptographyService

                .decryptData(this.storage.get("countryId"))

                .includes(x.id),
            );
          }

          this.categoryList = data.categories;

          this.locationTypeList = data.locationTypes;

          this.loading = false;

          observer.next(undefined);
        });
    });
  }

  // ============ COMPARE FUNCTION FOR SORTING ============

  compare(
    a: number | string | Date,

    b: number | string | Date,

    isAsc: boolean,
  ) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // ============ SORT DATA ============

  sortData(sort: Sort) {
    if (
      !sort.active ||
      sort.direction === "" ||
      !(this.equipmentItems && this.equipmentItems.length > 0)
    ) {
      return;
    }

    const isAsc = sort.direction === "asc";

    this.equipmentItems.sort((a, b) => {
      switch (sort.active) {
        case "type":
          return this.compare(
            a.standard?.equipmentStandard?.equipmentType?.name || "",

            b.standard?.equipmentStandard?.equipmentType?.name || "",

            isAsc,
          );

        case "supplier":
          return this.compare(
            a.standard?.equipmentStandard?.supplier?.name || "",

            b.standard?.equipmentStandard?.supplier?.name || "",

            isAsc,
          );

        case "title":
          return this.compare(
            a.standard?.title || "",

            b.standard?.title || "",

            isAsc,
          );

        case "model":
          return this.compare(
            a.standard?.equipmentStandard?.model || "",

            b.standard?.equipmentStandard?.model || "",

            isAsc,
          );

        case "class":
          return this.compare(
            a.standard?.equipmentStandard?.equipmentClassType?.name || "",

            b.standard?.equipmentStandard?.equipmentClassType?.name || "",

            isAsc,
          );

        default:
          return 0;
      }
    });
  }

  // ============ GO TO NEXT PAGE ============

  goToNextPage() {
    if (this.page < this.totalPages) {
      this.page++;

      if (
        this.isCountrySelected &&
        this.selectedCountryId &&
        this.selectedCountryId !== 0
      ) {
        this.getAllNrbesBySelectedCountryId();
      } else {
        this.getStandards();
      }
    }
  }

  // ============ GO TO PREVIOUS PAGE ============

  goToPreviousPage() {
    if (this.page > 1) {
      this.page--;

      if (
        this.isCountrySelected &&
        this.selectedCountryId &&
        this.selectedCountryId !== 0
      ) {
        this.getAllNrbesBySelectedCountryId();
      } else {
        this.getStandards();
      }
    }
  }

  // ============ SET USER PRIVILEGES ============

  setUserPrivilages() {
    if (!environment.skipAuthentication) {
      let userRoleUserOperation = this.storage.get("userRoleUserOperation")
        ? this.cryptographyService.decryptData(
            this.storage.get("userRoleUserOperation"),
          )
        : this.storage.get("userRoleUserOperation");

      if (userRoleUserOperation) {
        this.canEditNationalEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanEditNationalEquipmentStandard,
          ) !== -1;

        this.canDeleteNationalEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanDeleteNationalEquipmentStandard,
          ) !== -1;

        this.canRemoveEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanRemoveEquipmentStandard,
          ) !== -1;
      }
    } else {
      this.canEditNationalEquipmentStandard = true;

      this.canDeleteNationalEquipmentStandard = true;

      this.canRemoveEquipmentStandard = true;
    }
  }

  // ============ OPEN DELETE POPUP ============

  openDeletePopup(item, event) {
    event.stopPropagation();
    this.activePopupId = null;

    this.modalOption.backdrop = "static";
    this.modalOption.keyboard = false;

    const modalRef = this.ngbModal.open(
      DeleteDialogComponent,
      this.modalOption,
    );

    modalRef.componentInstance.title =
      "Do you want to remove this standard from the list? ";
    modalRef.componentInstance.deleteItem = item;

    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItem) => {
      if (deleteItem != null) {
        this.loading = true;

        if (this.isCountrySelected) {
          this.standardService
            .removeStandardFromNrbes(deleteItem.id)
            .subscribe(() => {
              this.isDeleted = false;
              this.loading = false;
              this.page = 1;
              this.getAllNrbesBySelectedCountryId();
            });
        } else {
          const grs = new SelectedStandard();
          grs.standard.id = deleteItem.id;
          grs.standard.isDeleted = true;
          this.standardService.removeGrbes(grs.standard).subscribe(() => {
            this.loading = false;
            this.page = 1;
            this.getStandards();
          });
        }
      }

      this.ngbModal.dismissAll();
    });
  }

  // ============ ADD ADDENDUM ============

  getEffectiveUserRole(): number {
    if (sessionStorage.getItem("userRoleId")) {
      return this.cryptographyService.decryptData(
        sessionStorage.getItem("userRoleId"),
      );
    }
    return this.cryptographyService.decryptData(this.storage.get("userRole"));
  }

  isGlobalAdmin(): boolean {
    return this.getEffectiveUserRole() === UserRoleEnum.GlobalAdmin;
  }

  showAddExceptionAction(item: any): boolean {
    if (!this.isGlobalAdmin()) {
      return false;
    }
    if (this.isCountrySelected) {
      return !item.availabileAddendumId;
    }
    return true;
  }

  showGoToExceptionAction(item: any): boolean {
    return (
      this.isGlobalAdmin() &&
      this.isCountrySelected &&
      !!item.availabileAddendumId
    );
  }

  getAddExceptionStandardId(item: any): number {
    if (this.isCountrySelected) {
      return item.standard?.id ?? item.standardId;
    }
    return item.id;
  }

  addAddendumFromList(item: any, event: MouseEvent): void {
    event.stopPropagation();
    this.activePopupId = null;
    this.addAddendum(this.getAddExceptionStandardId(item), event);
  }

  goToAddendumFromList(item: any, event: MouseEvent): void {
    event.stopPropagation();
    this.activePopupId = null;
    this.goToAddendum(item);
  }

  addAddendum(standardId: number, event): void {
    event.stopPropagation();
    this.addendumService.isCommingFromNationalEquipmentList = true;
    this.addendumService.isCommingFromAllStandards = false;
    this.addendumService.isCommingFromNrbes = this.isCountrySelected;
    this.router.navigate(["/add-addendum/" + standardId]);
  }

  // ============ GO TO ADDENDUM ============

  goToAddendum(nrbesItem: any): void {
    try {
      this.storage.set("adCountryId", nrbesItem.country);

      this.router.navigate(["/addendum/" + nrbesItem.availabileAddendumId]);
    } catch (e) {
      console.error(e);
    }
  }

  // ============ ON EDIT ============

  onEdit(item: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    this.standardService.standardEditPreviousRoute =
      this.activatedRoute.snapshot.routeConfig.path;

    const id =
      typeof item === "object"
        ? item.standard?.id || item.standardId || item.id
        : item;

    this.router.navigate(["/edit-eq-standards-global", id]);
  }

  // ============ CLOSE MAT MENU AND OPEN DELETE MODAL ============

  closeMatMenuAndOpenDeleteModal(item, event) {
    this.trigger.closeMenu();

    setTimeout(() => {
      this.openDeletePopup(item, event);
    }, 100);
  }

  // ============ ROW SELECTED ============

  rowSelected(item: any): void {
    this.standardService.fromLocationGRS = false;
    const stdId = item?.standard?.id || item?.standardId || item?.id;
    if (this.isCountrySelected) {
      this.router.navigate([
        "/view-national-equipments-standard-detail/" + stdId,
      ]);
    } else {
      this.router.navigate(["/view-equipments-standard-detail/" + stdId]);
    }
  }

  // ============ DOWNLOAD EXCEL ============

  downloadExcel(exportFilterList:any, exportCountryselectedIds: any[]) {
    this.isDownloading = true;

    this.standardService

      .downloadExcel(
        0,

        this.collectionSize,

        this.isCountrySelected ? StandardListType.NationalEquipment : StandardListType.GlobalEquipment,

        exportFilterList,

        this.isCountrySelected ? [this.selectedCountryId] : exportCountryselectedIds,

        null,
      )

      .subscribe(
        (response: any) => {
          this.isDownloading = false;
          let filename =
            "National_EquipmentStandard_List " + new Date().toLocaleString();
          this.standardService.saveExportBlob(response, filename);
        },

        (error: any) => {
          const modalRef = this.ngbModal.open(FailModuleComponent);

          modalRef.componentInstance.errorMessage = error.error
            ? error.error.Message
            : error.message;
        },
      );
  }

  getLocationNames(item): any {
    const std = item?.standard || item;
    if (std?.standardLocation && std.standardLocation.length > 0) {
      return std.standardLocation
        .map((loc) => loc.locationType?.name)
        .filter(Boolean)
        .join(", ");
    } else {
      return std?.locationType?.name || "";
    }
  }

  // ============ TOGGLE POPUP ============

  togglePopup(event: MouseEvent, item: any): void {
    event.stopPropagation();

    this.activePopupId = this.activePopupId === item.id ? null : item.id;
  }

  // ============ HOST LISTENER FOR CLICK OUTSIDE ============

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (!target.closest(".grid-actions")) {
      this.activePopupId = null;
    }
  }

  // ============ CHECKBOX SELECTION FOR EXPORT ============

  isSelected(id: number): boolean {
    return this.selectedRowsForExport.includes(id);
  }

  getSelectableRowsOnPage(): any[] {
    return this.equipmentItems || [];
  }

  getItemSelectionKey(item: any): number {
    return item.id || item.standard?.id;
  }

  isAllOnPageSelected(): boolean {
    const selectable = this.getSelectableRowsOnPage();
    if (selectable.length === 0) {
      return false;
    }
    return selectable.every((item) =>
      this.isSelected(this.getItemSelectionKey(item)),
    );
  }

  isSomeOnPageSelected(): boolean {
    const selectable = this.getSelectableRowsOnPage();
    if (selectable.length === 0) {
      return false;
    }
    const selectedCount = selectable.filter((item) =>
      this.isSelected(this.getItemSelectionKey(item)),
    ).length;
    return selectedCount > 0 && selectedCount < selectable.length;
  }

  selectAllOnPageChange(event: any): void {
    const selectable = this.getSelectableRowsOnPage();
    if (event.checked) {
      selectable.forEach((item) => {
        const key = this.getItemSelectionKey(item);
        if (!this.selectedRowsForExport.includes(key)) {
          this.selectedRowsForExport.push(key);
        }
      });
    } else {
      selectable.forEach((item) => {
        const key = this.getItemSelectionKey(item);
        const index = this.selectedRowsForExport.indexOf(key);
        if (index > -1) {
          this.selectedRowsForExport.splice(index, 1);
        }
      });
    }
  }

  onCheckboxChange(event: any, id: number) {
    if (event.checked) {
      if (!this.selectedRowsForExport.includes(id)) {
        this.selectedRowsForExport.push(id);

        console.log("Added:", id);
      }
    } else {
      const index = this.selectedRowsForExport.indexOf(id);

      if (index > -1) {
        this.selectedRowsForExport.splice(index, 1);
      }
    }
  }

  // ============ HANDLE EXPORT ============

  handleExport(exportFilterList:any) {
    this.downloadExcel(exportFilterList,this.exportSelectedIds);
  }

  handleCountryList(countryList: any) {   
    this.exportSelectedIds = countryList
  }
  
  

  // ============ GET COUNTRY NAME ============

  getCountryName(item: any): string {
    if (this.isNrbesData && item.countryId) {
      const country = this.countries.find((c) => c.id === item.countryId);

      return country ? country.name : "";
    }

    return "";
  }

  // ============ CHECK IF ITEM IS NRBES ============

  isNrbesItem(item: any): boolean {
    return item.isNrbes === true;
  }

  // ============ CHECK IF ITEM IS STANDARD ============

  isStandardItem(item: any): boolean {
    return item.isStandard === true;
  }

  onPageChange(): void {
  // Check if country is selected and call appropriate API
  if (this.isCountrySelected && this.selectedCountryId && this.selectedCountryId !== 0) {
    this.getAllNrbesBySelectedCountryId();
  } else {
    this.getStandards();
  }
}
}
